import * as React from 'react';
import { FunctionComponent } from 'react';
import classNames from 'classnames';
import { BaseButtonProps, buttonIconSizeStyle, buttonSizeStyle, stateStyles } from './buttonStates';
import { ButtonRightArrow } from './ButtonRightArrow';

export type ButtonColor =
  | 'primary'
  | 'secondary'
  | 'primary-red'
  | 'tertiary'
  | 'primary-green'
  | 'on-image'
  | 'breaking';

export type ButtonProps = BaseButtonProps & {
  trailingIcon?: React.FunctionComponent<{ className?: string }>;
  type?: 'button' | 'submit';
  arrow?: boolean;
  grow?: boolean;
  center?: boolean;
  invertIcon?: boolean;
  className?: string;
};

export const Button: FunctionComponent<ButtonProps> = ({
  invertIcon,
  color,
  darkMode,
  size,
  icon: Icon,
  trailingIcon: TrailingIcon,
  children,
  disabled,
  onClick,
  onMouseEnter,
  onMouseLeave,
  'data-testid': data_test_id,
  'aria-label': aria_label,
  'aria-describedby': aria_describedby,
  type = 'button',
  arrow,
  grow,
  center,
  className,
}) => {
  const iconStyle = buttonIconSizeStyle(size);
  return (
    <button
      disabled={disabled}
      data-testid={data_test_id}
      aria-describedby={aria_describedby}
      aria-label={aria_label}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={classNames(
        grow ? 'flex shrink-0 w-full' : 'inline-flex flex-none',
        'whitespace-nowrap gap-2 rounded-full items-center border-none',
        center ? 'justify-center' : '',
        buttonSizeStyle(size, Boolean(Icon), Boolean(arrow || TrailingIcon)),
        Object.values(stateStyles[color][darkMode ? 'darkMode' : 'lightMode']),
        className
      )}
      type={type === 'submit' ? 'submit' : 'button'}
      title={aria_label}
    >
      {Icon && <Icon className={classNames(iconStyle, { invert: invertIcon ?? false })} />}
      {children}
      {arrow && (
        <ButtonRightArrow className={classNames(iconStyle, { invert: invertIcon ?? false })} />
      )}
      {TrailingIcon && (
        <TrailingIcon className={classNames(iconStyle, { invert: invertIcon ?? false })} />
      )}
    </button>
  );
};
